/** @file Position, bone origin and rotation of one node read from a PoseBuffer (POSE_LAYOUT). */
import type { Quat } from '@zilo/pose3d-math/quat/quat';
import type { Vec3 } from '@zilo/pose3d-math/vec3/vec3';
import type { PoseBuffer } from '@zilo/pose3d-pose/contract';
import { POSE_LAYOUT as P } from '@zilo/pose3d-pose/layout/poseLayout';

/** A node's buffer columns render-core reads. */
export type PoseNode = { pos: Vec3; origin: Vec3; q: Quat; scale: number; flags: number; yaw: number; parentIndex: number };

/**
 * The columns of node `index`: entity-relative position and bone origin (`ox oy oz`, CR-003 21.5: pose writes it, place
 * never rebuilds it), world rotation, scale (1 when absent), flags, yaw, effective parent.
 */
export function poseNodeOf(pose: PoseBuffer, index: number): PoseNode {
  const o = index * P.stride;
  const at = (k: number): number => pose[o + k] ?? 0;
  return {
    pos: [at(P.px), at(P.py), at(P.pz)], origin: [at(P.ox), at(P.oy), at(P.oz)], q: [at(P.qx), at(P.qy), at(P.qz), at(P.qw)],
    scale: pose[o + P.scale] ?? 1, flags: at(P.flags), yaw: at(P.yaw), parentIndex: pose[o + P.parentIndex] ?? -1,
  };
}
